import styled from "styled-components/macro";
import classNames from "classnames";
import ProgressContainer from "../ProgressContainer";
import { themeVariables } from "../../themeVariables";

const PrimaryButtonContainer = styled.button`
  background: unset !important;
  border: unset !important;

  &.notLoading {
    & > div {
      &:hover {
        background: ${themeVariables.primaryCATHover} !important;
      }
      &:active {
        background: ${themeVariables.primaryCTAActive} !important;
      }
    }
  }
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px 8px 10px !important;
    height: 24px !important;
    border: 0px !important;
    border-radius: 10px !important;
    background-color: var(--primary-cta) !important;
    color: var(--cta-text-color) !important;
    font-weight: 500;
    font-size: 16px;
    font-family: "Inter";
    gap: 5px;
    span {
      margin-right: 3px;
    }
    cursor: pointer;
  }
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  &.loadingGoButton {
    cursor: progress;
    pointer-events: none;
  }
  svg {
    g {
      opacity: 1;
    }
    path {
      fill: var(--cta-text-color);
    }
  }
`;

function PrimaryButton({ onClick, ariaLabel, children, isLoading, loadingDuration = 60, disabled }) {
  return (
    <PrimaryButtonContainer
      aria-label={ariaLabel}
      onClick={onClick}
      className={classNames({ disabled, loadingGoButton: isLoading, notLoading: !isLoading })}
    >
      <ProgressContainer
        isLoading={isLoading}
        duration={loadingDuration}
      >
        {children}
      </ProgressContainer>
    </PrimaryButtonContainer>
  );
}

export default PrimaryButton;
